import './flash_component.scss'

document.addEventListener('turbo:before-render', () => {
  document.querySelectorAll('.flash').forEach((flash) => flash.remove())
})
